import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "a4-page",
  style: {"position":"relative","background-color":"var(--color-white)","border":"1px solid var(--color-light-gray)","box-shadow":"0 2px 8px rgba(0, 0, 0, 0.1)","width":"100%","aspect-ratio":"1/1.414","padding":"40px","overflow":"hidden"}
}
const _hoisted_2 = { class: "h5 fw-bold mb-3" }
const _hoisted_3 = {
  key: 1,
  class: "h5 fw-bold mb-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_plant_components_section = _resolveComponent("plant-components-section")!
  const _component_consumption_section = _resolveComponent("consumption-section")!
  const _component_cash_flow_section = _resolveComponent("cash-flow-section")!
  const _component_price_section = _resolveComponent("price-section")!
  const _component_date_signature_section = _resolveComponent("date-signature-section")!
  const _component_report_footer = _resolveComponent("report-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.$t("project.previewAndReport.sections.plantComponents")), 1),
    (_ctx.shouldShowPlantComponents)
      ? (_openBlock(), _createBlock(_component_plant_components_section, {
          key: 0,
          "report-type": _ctx.reportType,
          "selected-panels": _ctx.selectedPanels,
          "selected-inverters": _ctx.selectedInverters,
          "selected-batteries": _ctx.selectedBatteries,
          selectedEVChargers: _ctx.selectedEVChargers,
          "selected-meters": _ctx.selectedMeters,
          "get-panel-device-count": _ctx.getPanelDeviceCount,
          "get-inverter-device-count": _ctx.getInverterDeviceCount,
          "get-battery-device-count": _ctx.getBatteryDeviceCount,
          getEVChargerDeviceCount: _ctx.getEVChargerDeviceCount,
          "get-meter-device-count": _ctx.getMeterDeviceCount
        }, null, 8, ["report-type", "selected-panels", "selected-inverters", "selected-batteries", "selectedEVChargers", "selected-meters", "get-panel-device-count", "get-inverter-device-count", "get-battery-device-count", "getEVChargerDeviceCount", "get-meter-device-count"]))
      : _createCommentVNode("", true),
    (_ctx.shouldShowConsumption)
      ? (_openBlock(), _createElementBlock("h4", _hoisted_3, _toDisplayString(_ctx.$t("project.previewAndReport.sections.yieldEstimates")), 1))
      : _createCommentVNode("", true),
    (_ctx.shouldShowConsumption)
      ? (_openBlock(), _createBlock(_component_consumption_section, {
          key: 2,
          "consumption-data": _ctx.consumptionData
        }, null, 8, ["consumption-data"]))
      : _createCommentVNode("", true),
    (_ctx.shouldShowCashFlow)
      ? (_openBlock(), _createBlock(_component_cash_flow_section, {
          key: 3,
          "project-data": _ctx.projectData
        }, null, 8, ["project-data"]))
      : _createCommentVNode("", true),
    (_ctx.shouldShowPrice)
      ? (_openBlock(), _createBlock(_component_price_section, {
          key: 4,
          "project-data": _ctx.projectData,
          "payment-type": _ctx.paymentType,
          "report-type": _ctx.reportType
        }, null, 8, ["project-data", "payment-type", "report-type"]))
      : _createCommentVNode("", true),
    (_ctx.shouldShowSignature)
      ? (_openBlock(), _createBlock(_component_date_signature_section, {
          key: 5,
          "report-type": _ctx.reportType
        }, null, 8, ["report-type"]))
      : _createCommentVNode("", true),
    _createVNode(_component_report_footer, { "report-type": _ctx.reportType }, null, 8, ["report-type"]),
    _cache[0] || (_cache[0] = _createElementVNode("div", {
      class: "position-absolute bottom-0 end-0",
      style: {"padding":"20px 40px"}
    }, [
      _createElementVNode("small", {
        class: "text-muted",
        style: {"font-size":"12px"}
      }, "2")
    ], -1))
  ]))
}